import URL from 'url';

export const POSSIBLE_URL_REGEX = /(\b(?:https?:\/\/|[a-z])\S*\.[a-z]{2,}(?:(?:\/|\?|#)\S*)?\b)/i;
const HTTP_PROTOCOLS_REGEX = /^https?:\/\//;

export function isValidUrl(url) {
  return POSSIBLE_URL_REGEX.test(url);
}

export function normalizeUrl(url, protocolIfMissing = 'http:') {
  const urlObj = URL.parse(url);
  urlObj.slashes = true;
  urlObj.protocol || (urlObj.protocol = protocolIfMissing);
  return urlObj.format().replace('///', '//');
}

/**
 * calls cb on all possible urls; returns textChunk as-is when not a url
 */
export function mapUrlsInText(text, cb) {
  return text
    .split(POSSIBLE_URL_REGEX)
    .map((textChunk, idx) => {
      if (idx % 2 !== 0) { // possible url
        const url = normalizeUrl(textChunk);

        if (HTTP_PROTOCOLS_REGEX.test(url)) {
          return cb(url, textChunk, idx);
        }
      }

      return textChunk;
    });
}

export function stripProtocol(url) {
  return url.replace(HTTP_PROTOCOLS_REGEX, '');
}
